import "core-js/modules/es.array.concat";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.promise";

/*
 * Copyright (c) 2020 Wells Fargo. 45 Fremont Street, San Francisco, CA 94105 All rights reserved.
 *
 *This software is the confidential and proprietary information of Wells Fargo
 *bank. ('Confidential Information'). You shall not disclose such Confidential
 *Information and shall use it only in accordance with the terms of the license
 *agreement you entered into with WellsFargo.
 *
 *Author: Thomas Barry
*/
import { extractJson } from 'wfui-digital-core/es/lib';
import globals from '../../../lib/globals/globals';
import getJson from '../../../lib/network/get-json';
import extractJsonFromString from './extract-json-from-string';

var fetchMenuConfig = function fetchMenuConfig() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      language = _ref.language,
      platform = _ref.platform;

  if (globals().menuContext) {
    var _globals = globals(),
        menuContext = _globals.menuContext;

    if (typeof menuContext === 'string') {
      return extractJsonFromString(menuContext);
    }

    var menuConfig = menuContext.menuConfig;

    if (typeof menuConfig === 'string') {
      return extractJson(menuConfig);
    }

    if (menuConfig.containers) {
      return Promise.resolve(menuConfig);
    }
  } else if (globals().localServerMode) {
    return getJson({
      url: "/menuConfig/".concat(language, "/").concat(platform)
    });
  }

  return Promise.resolve({
    containers: []
  });
};

export default fetchMenuConfig;